import React, { useState, useEffect } from 'react'
import { toggleSidebar, selectCategory } from '../../redux/slices/changeMenuStateSlice'
import { useSelector, useDispatch } from 'react-redux'
import CHIP from '../../assets/images/chip.png'
import { FormattedMessage } from "react-intl";
import { toast } from 'react-toastify';
import GeneralService from '../../apis/GeneralService';
import ApiURL from '../../apis/ApiURL';
import Constants from '../../utility/Constants';
import { createMd5hashFun } from '../../utility/createHash';
import MAINLOGO from '../../assets/images/BYKUSH_Logo.png'
import { Link } from 'react-router-dom';

// Map a category name to a distinct Font Awesome icon (portal already loads FA).
const categoryIcon = (name = '') => {
    const n = String(name).toLowerCase();
    if (n.includes('all')) return 'fa-solid fa-border-all';
    if (n.includes('slot')) return 'fa-solid fa-coins'; // usually coins, bell, or slot machine
    if (n.includes('live')) return 'fa-solid fa-headset'; // dealers/headset
    if (n.includes('crash')) return 'fa-solid fa-rocket';
    if (n.includes('lottery') || n.includes('lotto') || n.includes('keno')) return 'fa-solid fa-ticket';
    if (n.includes('poker') || n.includes('qipai') || n.includes('p2p')) return 'fa-solid fa-heart'; // suits
    if (n.includes('shoot')) return 'fa-solid fa-crosshairs';
    if (n.includes('fish')) return 'fa-solid fa-fish';
    if (n.includes('table')) return 'fa-solid fa-dice'; // table games = dice/cards
    if (n.includes('virtual')) return 'fa-solid fa-vr-cardboard'; // vr or futbol
    if (n.includes('instant')) return 'fa-solid fa-bolt';
    if (n.includes('show')) return 'fa-solid fa-tv';
    if (n.includes('esport') || n.includes('e-sport')) return 'fa-solid fa-gamepad';
    if (n.includes('sport') || n.includes('book')) return 'fa-solid fa-football';
    if (n.includes('cock')) return 'fa-solid fa-crow';
    if (n.includes('bonus') || n.includes('promo')) return 'fa-solid fa-gift';
    if (n.includes('other')) return 'fa-solid fa-shapes';
    return 'fa-solid fa-gamepad'; // default fallback
};


const Sidebar = () => {

    const dispatch = useDispatch();
    const menuStatus = useSelector((state) => state.menuState);
    const languageState = useSelector((state) => state.languageState);
    const userDetailState = useSelector((state) => state.userDetailState);
    let languageCode = languageState.active_language.language_code;
    const categoryId = useSelector((state) => state.menuState.categorty) || 'all';
    const selectedAggregator = useSelector((state) => state.menuState?.selectedAggregator) || 'all';
    const toggleSidebarMenu = () => {
        dispatch(toggleSidebar())
    }

    const [state, setState] = useState({
        client_id: process.env.REACT_APP_CLIENT_ID || "683059b54a3eeeaad7ee3f18",
        language: "",
        categoryList: [],
        selectedCategory: ''
    })

    useEffect(() => { if (userDetailState?.user_details?.account_id){ GetCategoriesList(selectedAggregator); }
 // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [userDetailState?.user_details, selectedAggregator])

    /**
  * @author Sarmistha Mondal
  * @Date_Created  06.02.2025
  * @Date_Modified 
  * @function sync
  * @functionName GetCategoriesList
  * @functionPurpose this function for get categories list details.
  *
  * @functionParam {payload object: account_id ,client_id,hash_token}
  * 
  * @functionSuccess Success status and message.
  *
  * @functionError {Boolean} error error is there.
  * @functionError {String} message  Description message.
  */
    const GetCategoriesList = (aggId) => {
        toast.dismiss();
        let req_body = {
            account_id: userDetailState?.user_details?.account_id,
            client_id: state.client_id,
        }

        let generatedHash = createMd5hashFun(req_body, userDetailState?.user_details?.account_key);
        let params = {
            "client_id": state.client_id,
            "account_id": userDetailState?.user_details?.account_id,
            "hash_token": generatedHash,
        };
        // Aggregator-aware: only categories that have games under this aggregator
        // (not part of the hash). Empty / 'all' => categories across all aggregators.
        if (aggId && aggId !== 'all') params.provider_parent_id = aggId;

        GeneralService.apiPostCallRequest(ApiURL.getCategories, params)
            .then((res) => {
                if (res.err === Constants.API_RESPONSE_ERROR_FALSE) {
                    let cats = res.data.categories || [];
                    
                    // Custom priority order for categories
                    const getOrder = (name) => {
                        const n = String(name).toLowerCase();
                        if (n.includes('slot')) return 1;
                        if (n.includes('live')) return 2;
                        if (n.includes('virtual')) return 3;
                        if (n.includes('crash')) return 4;
                        if (n.includes('other')) return 999;
                        return 50; // default for rest
                    };
                    
                    cats.sort((a, b) => getOrder(a.category_name) - getOrder(b.category_name));

                    setState(prevState => ({
                        ...prevState,
                        categoryList: cats,
                    }))

                } else {
                    toast.error(res.message, {
                        position: 'bottom-right',
                        autoClose: false,
                    });
                }
            })
            .catch((error) => {
                // console.log(error);
                if (error?.response?.status === 400) {
                    toast.error(error.response.data.message, {
                        position: 'bottom-right',
                        autoClose: false,
                    });
                } else if (error?.response?.status === 404) {
                    toast.error(error.response.data.message, {
                        position: 'bottom-right',
                        autoClose: false,
                    });
                } else {
                    console.error('GetCategoriesList network error:', error.message);
                }
            });
    }

    const onChangeCategory = (category_id) => {
        setState(prevState => ({
            ...prevState,
            selectedCategory: category_id,
        }))
        dispatch(selectCategory(category_id))
    }

    useEffect(() => {
        // console.log(state.selectedCategory, categoryId);
    }, [state.selectedCategory]);


    return (
        <nav
            className={`sidebar ${menuStatus?.active_sidebar ? '' : ''}`}
        >
            <header>
                <div className="image-text">
                    <span className="image sidebar-logo-wrapper">
                        <Link to="/" className="sidebar-logo-ring">
                            <img width={100} src={MAINLOGO} alt="ByKush" />
                        </Link>
                    </span>
                    <div className="text logo-text">
                    </div>
                </div>

            </header>
            <div className="menu-bar">
                <div className="menu">
                    {
                        <>
                        {/* className={`fa-solid fa-chevron-${menuStatus?.active_sidebar == false ? 'down' : 'up'}`} */}

                            <h6 className="menubar_big_txt"><i className="fa-solid fa-trophy me-2"></i>
                                <FormattedMessage id='CATEGORIES' /> &nbsp;<i className={`fa-solid fa-chevron-${userDetailState?.user_details?.account_id ? 'up' : 'down'}`}
                                    onClick={() => toggleSidebarMenu()}
                                />
                            </h6>

                            {(userDetailState?.user_details?.account_id ) ? <ul className="menu-links">
                                <li className={`nav-link ${categoryId === 'all' ? 'active' : ''}`} onClick={() => onChangeCategory('all')}>
                                    <i className={`fa-solid fa-border-all cat-ico ${categoryId === 'all' ? 'active' : ''}`} />
                                    <span className="text nav-text"><FormattedMessage id="ALL" defaultMessage="All" /></span>
                                </li>
                                {state.categoryList?.length > 0 ? state.categoryList.map((gameCategoryData, index) => {
                                    const active = categoryId === String(gameCategoryData?.category_id);
                                    const catName = String(gameCategoryData?.category_name).toLowerCase();
                                    const isSlot = catName.includes('slot');
                                    return (
                                    <li className={`nav-link ${active ? 'active' : ''}`} onClick={() => onChangeCategory(String(gameCategoryData?.category_id))} key={index}>
                                        {isSlot ? (
                                            <svg className={`cat-ico ${active ? 'active' : ''}`} viewBox="0 0 64 64" fill="currentColor" width="1em" height="1em" style={{ fontSize: '20px' }}>
                                                {/* Dome */}
                                                <path d="M 12 24 C 12 6, 44 6, 44 24 Z" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                                                {/* Body */}
                                                <rect x="8" y="24" width="40" height="24" fill="none" stroke="currentColor" strokeWidth="4" strokeLinejoin="round"/>
                                                {/* Base */}
                                                <rect x="12" y="48" width="32" height="12" fill="none" stroke="currentColor" strokeWidth="4" strokeLinejoin="round"/>
                                                <line x1="18" y1="54" x2="38" y2="54" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
                                                {/* Dividers */}
                                                <line x1="21" y1="24" x2="21" y2="48" stroke="currentColor" strokeWidth="4"/>
                                                <line x1="35" y1="24" x2="35" y2="48" stroke="currentColor" strokeWidth="4"/>
                                                {/* 7s */}
                                                <polyline points="12,32 17,32 14,42" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                <polyline points="25,32 30,32 27,42" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                <polyline points="39,32 44,32 41,42" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                {/* Lever */}
                                                <path d="M 48 36 C 56 36, 56 30, 56 26 L 56 12" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                                                <circle cx="56" cy="8" r="4" fill="currentColor"/>
                                            </svg>
                                        ) : (
                                            <i className={`${categoryIcon(gameCategoryData.category_name)} cat-ico ${active ? 'active' : ''}`} />
                                        )}
                                        <span className="text nav-text">
                                            <FormattedMessage 
                                                id={`CATEGORYNAME${gameCategoryData.category_name.replace(/\s+/g, '').toUpperCase()}`} 
                                                defaultMessage={gameCategoryData.category_name} 
                                            />
                                        </span>
                                    </li>
                                    );
                                })
                                    : ""}
                            </ul> : ""}
                        </>
                    }
                </div>
            </div>
        </nav >
    )
}

export default Sidebar